import * as React from 'react';
import { useRef } from 'react';
import {
    Box,
    Button,
    makeStyles,
    createStyles,
    Theme as ITheme,
} from '@material-ui/core';
import RecordIcon from '../../../Assets/recordbr.png';
import Draggable from 'react-draggable';

const indents = {
    left: 4,
    bottom: 48,
};

const useStyles = makeStyles((theme: ITheme) =>
    createStyles({
        snackbar: {
            left: indents.left,
            bottom: indents.bottom,
        },
        container: {
            background: theme.palette.primary.dark,
            minWidth: 'auto',
            padding: theme.spacing(1.5),
            paddingLeft: theme.spacing(2.5),
        },
        button: {
            fontWeight: 'bold' as 'bold',
            minWidth: 'auto',
            height: 20,
            left: 0,
            borderRadius: theme.spacing(1),
            margin: 8,
        },
        '@keyframes woong': {
            '0%': {
                transform: 'scale(1.2)',
            },
            '50%': {
                transform: 'scale(1.8)',
                opacity: 0.5,
            },
            '100%': {
                transform: 'scale(2.4)',
                opacity: 0,
            },
        },
        '@keyframes woong-2': {
            '0%': {
                transform: 'scale(1.2)',
                opacity: 0.6,
            },
            '50%': {
                transform: 'scale(1.6)',
                opacity: 0.5,
            },
            '100%': {
                transform: 'scale(2)',
                opacity: 0,
            },
        },
        recorder: {
            display: 'block',
            borderRadius: '100%',
            cursor: 'default',
            position: 'relative',
        },
        micro: {
            color: '#fff',
            height: theme.spacing(3),
            width: theme.spacing(3),
            borderRadius: '100%',
            display: 'block',
            textAlign: 'center',
            backgroundColor: theme.palette.primary.main,
            position: 'relative',
        },
        outer: {
            width: theme.spacing(3),
            height: theme.spacing(3),
            transform: 'scale(1)',
            borderRadius: '100%',
            position: 'absolute',
            transition: '1.5s all ease',
            '&:first-child': {
                backgroundColor: 'transparent',
                border: `1px solid ${theme.palette.grey[400]}`,
                animation: '$woong 1.5s infinite',
            },
            '&:nth-child(2)': {
                backgroundColor: theme.palette.grey[500],
                animation: '$woong-2 1.5s infinite',
                animationDelay: '2.5s',
            },
        },
    })
);

interface IBounds {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
}

interface IProps {
    open: boolean;
    onStopRecording: () => void;
}

export const StopRecording = ({ onStopRecording, open }: IProps) => {
    const classes = useStyles();
    const containerRef = useRef<HTMLDivElement>();

    const message = (
        <Box>
            <Box className={classes.recorder}>
                <Box className={classes.outer}></Box>
                <Box className={classes.outer}></Box>
                <Box className={classes.micro}></Box>
            </Box>
        </Box>
    );

    const button = (
        <Button
            key='undo'
            style={{
                float: 'right',
                margin: 8,
                marginTop: -29,
                backgroundColor: '#DB2C29',
                color: '#fff',
                borderRadius: 8,
            }}
            onClick={onStopRecording}
        >
            End Recording
        </Button>
    );

    const bounds: IBounds = {};

    if (open) {
        return (
            <Box
                style={{
                    zIndex: 5000,
                    position: 'absolute',
                    height: 54,
                    left: 64,
                    paddingLeft: 10,
                    top: 70,
                    bottom: 'auto',
                    width: 'calc(100% - 64px)',
                    backgroundColor: '#3F3F50',
                }}
            >
                <div style={{ width: '130px' }}>
                    <img
                        style={{ marginTop: 8, float: 'left' }}
                        src={RecordIcon}
                    />
                    <div style={{ marginTop: 19, float: 'right' }}>
                        {' '}
                        Recording...
                    </div>
                </div>

                {button}
            </Box>
        );
    }

    return <Box />;
};
